import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Directive } from '@angular/core';
import * as _ from 'lodash';

@Directive()
export abstract class PrAutresFormBuilder extends PrFormAbstract {
  getDuration() {
    let date =
      (new Date(this.form.value.endDate).getFullYear() -
        new Date(this.form.value.startDate).getFullYear()) *
      12;
    return date;
  }

  generate(entity: any) {
    let options: AbstractControlOptions = {};

    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null],
        type: [entity ? entity.type : null, Validators.required],
        label: [entity ? entity.label : null, Validators.required],
        purchasePrice: [entity ? entity.purchasePrice : null],
        lastValue: [entity ? entity.lastValue : null, Validators.required],
        duration: [entity ? entity.duration : null],
        startDate: [entity ? entity.startDate : null, Validators.required],
        endDate: [entity ? entity.endDate : null],
        contratId: [entity ? entity.contratId : null, Validators.required],
        managerProviderId: [entity ? entity.managerProviderId : null],
        source: [entity ? entity.source : null, Validators.required],
        accountId: [entity ? entity.accountId : null, Validators.required],
        userId: [entity ? entity.userId : null, Validators.required],
        subscriptionId: [entity ? entity.subscriptionId : null],
        owners: [this.buildInitialOwners(entity), Validators.required],
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      id: this.emptyIsNull(this.form.value.id),
      type: this.emptyIsNull(this.form.value.type),
      label: this.emptyIsNull(this.form.value.label),
      purchasePrice: this.emptyIsNull(this.form.value.purchasePrice),
      lastValue: this.emptyIsNull(this.form.value.lastValue),
      duration: this.emptyIsNull(
        this.form.value.endDate
          ? this.getDuration()
          : this.form.value.duration * 12,
      ),
      startDate:
        new Date(this.form.value.startDate).toISOString().split('.')[0] + 'Z',
      endDate: this.form.value.endDate
        ? new Date(this.form.value.endDate).toISOString().split('.')[0] + 'Z'
        : null,
      contratId: this.emptyIsNull(
        this.form.value.contratId.name
          ? this.form.value.contratId.name
          : this.form.value.contratId,
      ),
      subscriptionSource: this.emptyIsNull(this.form.value.source),
      managerProviderId: this.emptyIsNull(
        this.form.value.contratId?.id ?? this.form.value.managerProviderId,
      ),
      accountId: this.emptyIsNull(this.form.value.accountId),
      userId: this.emptyIsNull(this.form.value.userId),
      subscriptionId: this.emptyIsNull(this.form.value.subscriptionId),
      owners: this.form.value.owners,
    };
    return dto;
  }
}
